'use strict';

const React = require('react');
const SVTLink = require('../elements/SVTLink');

const MenuLink = (props) => {
	return (
		<SVTLink to={props.model.url} {...props}>
			{props.children}
		</SVTLink>
	);
};
	
MenuLink.propTypes = {
	model: React.PropTypes.object.isRequired
};

export default MenuLink;



/** WEBPACK FOOTER **
 ** ./app/components/menu/MenuLink.js
 **/